import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  deleteAllDescription?: string;
  deleteAllSuccessText?: string;
  deleteDescription?: string;
  deleteSuccessText?: string;
  id?: number;
  updateData: () => Promise<void>;
  urlState: string;
}

const ProductUserCustomAttributesDelete = ({
  deleteAllDescription,
  deleteAllSuccessText,
  deleteDescription,
  deleteSuccessText,
  id,
  updateData,
  urlState
}: Props) => {
  const { messages } = useReduxState();

  const remove = async () => {
    await api.delete(
      `/admin/product-user-custom-attributes/${urlState}${id ? `/${id}` : ''}`
    );
    await updateData();
    return true;
  };

  const textProps = id
    ? {
        buttonText: messages.commonDelete,
        confirmText: deleteDescription || messages.attributesDeleteConfirm,
        confirmTitle: messages.commonDelete,
        successMessage: deleteSuccessText || messages.attributesDeleteSuccess
      }
    : {
        buttonText: messages.commonDeleteAll,
        confirmText:
          deleteAllDescription || messages.attributesDeleteConfirmAll,
        confirmTitle: messages.commonDeleteAll,
        successMessage:
          deleteAllSuccessText || messages.attributesDeleteSuccessAll
      };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={Boolean(id)}
      category="danger"
      onConfirm={remove}
      stopPropagation={true}
      {...textProps}
    />
  );
};

export default ProductUserCustomAttributesDelete;
